import { render, staticRenderFns } from "./article-tag-table.vue?vue&type=template&id=5d01334c&scoped=true&"
import script from "./article-tag-table.ts?vue&type=script&lang=ts&"
export * from "./article-tag-table.ts?vue&type=script&lang=ts&"
import style0 from "./article-tag-table.scss?vue&type=style&index=0&id=5d01334c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d01334c",
  null
  
)

export default component.exports